<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>
<script>
import api from "./api";
import store from "./store"
export default {
  data() {
    return {
      common_info: {
        store: {},
      },
    };
  },
  beforeCreate() {
    try {
      api
        .business_bridge()
        .then((res) => {
          document.getElementById("baidu") &&
            document.getElementById("baidu").remove();
          if (res.data && res.data.bridge_code) {
            var hm = document.createElement("script");
            hm.innerText = res.data.bridge_code;
            hm.id = "baidu";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(hm, s);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    getdata() {
      var that = this;
      this.$api
        .store()
        .then((res) => {
          if (res.code == 0) {
            // console.log(res)
            sessionStorage.setItem("appStore", JSON.stringify(res.data));
            document.title = res.data.store.name;
          }
        })
        .catch((err) => {
          this.common.message(this, err);
        });
    },
  },
  created() {
    this.common.getCommonInfo(this, function () {
      console.log('app')
      /* that.ttshop_name = that.common_info.store.name;
				document.title = that.common_info.store.name; */
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = that.common_info.store.icon;
      document.getElementsByTagName("head")[0].appendChild(link);
      /* let head = document.getElementsByTagName("head");
				let meta = document.createElement("meta");
				document.querySelector('meta[name="keywords"]').setAttribute("content", that.common_info.store.seo_key);
				document.querySelector('meta[name="description"]').setAttribute("content", that.common_info.store.seo_desc); */
    });
    this.getdata();
    let that = this;
    console.log(this.$store.state.common_info)
  },
};
</script>
<style lang="scss">
</style>
